import ConversationPanel from "./ConversationPanel.tsx";
import CirclePanel from "../circle/CirclePanel.tsx";
import CircleContent from "../circle/CircleContent.tsx";
import ConversationDrawer from "./ConversationDrawer.tsx";
import IntegrationsPage from "../integration/IntegrationsPage.tsx";
import MemoriesPage from "../memory/MemoriesPage.tsx";
import { Box, Grid } from "@mui/material";
import { useTypedSelector } from "../../hooks.tsx";
import * as React from "react";
import { i18n } from "@lingui/core";
import { I18nProvider } from "@lingui/react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  conversationActions,
  fetchExchanges,
} from "../../store/conversation.tsx";

function ConversationContainer() {
  const { isLoggedIn, anonymousSession } = useTypedSelector(
    (state) => state.authState,
  );

  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const [openDrawer, setOpenDrawer] = React.useState(false);
  const [showIntegrations, setShowIntegrations] = React.useState(
    location.pathname === "/integrations",
  );
  const [showMemories, setShowMemories] = React.useState(
    location.pathname === "/memories",
  );

  React.useEffect(() => {
    setShowIntegrations(location.pathname === "/integrations");
    setShowMemories(location.pathname === "/memories");
  }, [location.pathname]);

  // When the URL contains ?conversation=..., show that conversation instead of
  // any locally selected side page such as integrations or memories.
  React.useEffect(() => {
    const params = new URLSearchParams(location.search);
    const conversationId = params.get("conversation");
    if (!conversationId || anonymousSession || !isLoggedIn) {
      return;
    }

    setShowIntegrations(false);
    setShowMemories(false);
    dispatch(conversationActions.setSelectedView("conversation"));
    dispatch(conversationActions.setSelectedConversation(conversationId));
    dispatch(fetchExchanges(conversationId) as any);
  }, [anonymousSession, dispatch, isLoggedIn, location.search]);

  if (!(isLoggedIn || anonymousSession)) {
    return (
      <I18nProvider i18n={i18n}>
        <CirclePanel>
          <CircleContent />
        </CirclePanel>
      </I18nProvider>
    );
  }

  if (anonymousSession) {
    return (
      <I18nProvider i18n={i18n}>
        <Grid>
          <ConversationPanel openDrawer={false} />;
        </Grid>
      </I18nProvider>
    );
  } else {
    return (
      <I18nProvider i18n={i18n}>
        <Box width="100%">
          <ConversationDrawer
            openDrawer={openDrawer}
            setOpenDrawer={setOpenDrawer}
            onShowIntegrations={() => {
              setShowMemories(false);
              setShowIntegrations(true);
              navigate("/integrations");
            }}
            onShowMemories={() => {
              setShowIntegrations(false);
              setShowMemories(true);
              navigate("/memories");
            }}
            onConversationSelected={() => {
              setShowIntegrations(false);
              setShowMemories(false);
              if (
                location.pathname === "/integrations" ||
                location.pathname === "/memories"
              ) {
                navigate("/", { replace: true });
              }
            }}
          />
          {showIntegrations ? (
            <IntegrationsPage
              openDrawer={openDrawer}
              setOpenDrawer={setOpenDrawer}
            />
          ) : showMemories ? (
            <MemoriesPage
              openDrawer={openDrawer}
              setOpenDrawer={setOpenDrawer}
            />
          ) : (
            <ConversationPanel
              openDrawer={openDrawer}
              setOpenDrawer={setOpenDrawer}
            />
          )}
        </Box>
      </I18nProvider>
    );
  }
}

export default ConversationContainer;
